import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Music2, Phone } from "lucide-react";
import { EMAIL, EMAIL_MAILTO, PHONE_DISPLAY, PHONE_TEL, SOCIALS } from "@/data/services";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#1B1B1E] border-t border-white/5">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
      <div>
        <p className="font-display uppercase text-sm font-medium tracking-[0.15em] text-white">
          Hello, we are Brad's Mobile Detailing
        </p>
        <p className="mt-4 text-sm text-slate-400 leading-relaxed">
          Our experienced technicians provide quality services for your cars.
        </p>
      </div>

      <div>
        <p className="font-display uppercase text-sm font-medium tracking-[0.15em] text-white">Office</p>
        <p className="mt-4 text-sm text-slate-400 leading-relaxed">
          Call, Text{" "}
          <a href={PHONE_TEL} data-testid="footer-phone-link" className="text-slate-200 hover:text-[#FF4311] transition-colors">
            {PHONE_DISPLAY}
          </a>{" "}
          or Email us to setup your appointment.
        </p>
        <p className="mt-4 text-sm text-slate-200 underline underline-offset-4 decoration-slate-500">
          Charlotte, NC and Surroundings
        </p>
        <a href={EMAIL_MAILTO} data-testid="footer-email-link" className="mt-3 block text-sm font-semibold text-slate-200 hover:text-[#FF4311] transition-colors">
          {EMAIL}
        </a>
        <a href={PHONE_TEL} className="mt-1 block text-sm font-semibold text-slate-200 hover:text-[#FF4311] transition-colors">
          {PHONE_DISPLAY}
        </a>
      </div>

      <div>
        <p className="font-display uppercase text-sm font-medium tracking-[0.15em] text-white">Links</p>
        <div className="mt-4 flex flex-col gap-2.5 text-sm">
          <Link to="/" data-testid="footer-home-link" className="text-slate-300 hover:text-[#FF4311] transition-colors">Home</Link>
          <a href="/#services" data-testid="footer-services-link" className="text-slate-300 hover:text-[#FF4311] transition-colors">Services</a>
          <Link to="/about-us" data-testid="footer-about-link" className="text-slate-300 hover:text-[#FF4311] transition-colors">About Us</Link>
          <Link to="/packages" data-testid="footer-packages-link" className="text-slate-300 hover:text-[#FF4311] transition-colors">Packages</Link>
          <Link to="/contact-us" data-testid="footer-contact-link" className="text-slate-300 hover:text-[#FF4311] transition-colors">Contact Us</Link>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-slate-500 hover:text-slate-300 transition-colors">Owner Login</Link>
        </div>
      </div>

      <div>
        <p className="font-display uppercase text-sm font-medium tracking-[0.15em] text-white">Get in Touch</p>
        <div className="mt-4 flex flex-col gap-3 text-sm">
          <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="inline-flex items-center gap-3 text-slate-300 hover:text-[#FF4311] transition-colors">
            <Facebook className="w-4 h-4" /> Facebook
          </a>
          <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="inline-flex items-center gap-3 text-slate-300 hover:text-[#FF4311] transition-colors">
            <Instagram className="w-4 h-4" /> Instagram
          </a>
          <a href={SOCIALS.google} target="_blank" rel="noopener noreferrer" data-testid="footer-google-link" className="inline-flex items-center gap-3 text-slate-300 hover:text-[#FF4311] transition-colors">
            <MapPin className="w-4 h-4" /> Location
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 px-4 sm:px-6 lg:px-8">
      <p className="max-w-[1400px] mx-auto text-xs text-slate-500">
        Brad's Mobile Detailing, LLC © {new Date().getFullYear()}. All rights reserved.
      </p>
    </div>
  </footer>
);
